import React, { useEffect } from 'react';
import { EnergyProvider, useEnergyCheckout } from './energy.context';
import { IEnergyManager } from '@vfit/consumer/providers';
import { ENABLE_DEBUG } from './energy.utils';
import EnableDebug from './Debug/enableDebug/enableDebug';
import CheckoutEnergy from './CheckoutEnergy/checkoutEnergy.modal';

const EnergyOffer = ({ product, onClose }: IEnergyManager) => {
  const { setProduct } = useEnergyCheckout();

  useEffect(() => {
    if (product) setProduct({ ...product });
  }, []);

  if (!product || Object.keys(product)?.length === 0) return null;

  return (
    <>
      {ENABLE_DEBUG && <EnableDebug />}
      <CheckoutEnergy
        isOpen
        handleClose={() => onClose?.()}
        backgroundImage={product?.image || ''}
        isLoadingCart={false}
      />
    </>
  );
};

const Energy = (props: IEnergyManager) => (
  <EnergyProvider>
    <EnergyOffer {...props} />
  </EnergyProvider>
);

export default Energy;
